(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DettaglioOrdineDetailController', DettaglioOrdineDetailController);

    DettaglioOrdineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DettaglioOrdine', 'Ordine'];

    function DettaglioOrdineDetailController($scope, $rootScope, $stateParams, previousState, entity, DettaglioOrdine, Ordine) {
        var vm = this;

        vm.dettaglioOrdine = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:dettaglioOrdineUpdate', function(event, result) {
            vm.dettaglioOrdine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
